import { Searchbar as PaperSearchbar } from "react-native-paper";
import { styled } from "nativewind";
import type { SearchbarProps } from "react-native-paper";

const StyledSearchbar = styled(PaperSearchbar);

interface SearchbarComponentProps extends SearchbarProps {
  className?: string;
}

export default function Searchbar({ className, style, ...props }: SearchbarComponentProps) {
  return <StyledSearchbar className={className} style={style} {...props} />;
}
